<template>
	<div class="container" v-wechat-title="$route.meta.title">
		<div class="topTitle"><img @click="goStore" class="backImg" src="../assets/pingzi/back.png" alt="">{{$route.meta.title}}</div>
		<div style="width: 100%;height: 0.8rem;background: transparent;"></div>
		<img class="topImg" src='../assets/newicon/paySuccess.png' />
		<!-- 顶部文字描述 -->
		<div class="topDes">
			<div class="topBox">
				<span class="">支付成功</span>
			</div>
		</div>
		<!-- 按钮 -->
		<div class="btngroup">
			<div class="btn1 " hover-class="btnHover" @click="goStore">
				<span class="">首页</span>
			</div>
			<div class="btn2 " hover-class="btnHover" @click="toDetail" v-if="orderShow != 2">
				<span class="">查看订单</span>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import util from "../utils/util";
import { Toast } from "vant";
import { RadioGroup, Radio } from "vant";
Vue.use(RadioGroup);
Vue.use(Radio);
import { Loading } from "vant";
Vue.use(Loading);

Vue.use(Toast);
import baseUrl from "../utils/basedata.js";

export default {
  name: "paySuccess",
  data() {
    return {
      orderId: null,
      orderShow: 1,
    };
  },
  created: function() {
    this.$parent.Loading(false);
    this.$emit("footer", false);
  },
  components: {},
  methods: {
    backLast() {
      this.$router.go(-1); //返回上一层
    },
    goStore() {
      this.$router.push({
        path: "/",
        query: {from:'paySucess'},
      });
    },
    toDetail() {
      util.setSto("tabActive", 2);
      // this.$router.push({
      // 		path: '/orderDetail',
      // 		query: {
      // 			showback: 1,
      // 			id: this.orderId,
      // 			type: this.$route.query.type,
      // 			ordertype: this.$route.query.ordertype
      // 		}
      // 	})
      this.$router.replace(`/orderDetail/${this.orderId}`);
    },
  },
  mounted() {
    this.orderId = this.$route.query.id;
    this.orderShow = util.getSto("acNogoods") || 1;

    util.setSto("tabOrderMsg", 3);
  },
  beforeDestroy() {
    util.setSto("acNogoods", 1);
  },
};
</script>

<style scoped lang="scss">
@import url("../styles/base1.css");

.container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  // padding: 0.15rem;
  background-color: white;
  text-align: center;
  font-size: 0.34rem;
  color: #1c1c1c;
  font-weight: bold;
}

.topImg {
  width: 2.48rem;
  margin: auto;
  margin-top: 1rem;
}

.topBox {
  margin-top: 0.5rem;
}

.btn1 {
  width: 2.8rem;
  height: 0.8rem;
  background: rgba(255, 255, 255, 1);
  border: 0.02rem solid rgba(79, 174, 84, 1);
  border-radius: 0.4rem;
  font-size: 0.28rem;
  line-height: 0.8rem;
  color: #4fae54;
}

.btn2 {
  width: 2.8rem;
  height: 0.8rem;
  background: rgba(79, 174, 84, 1);
  box-shadow: 0px 9px 19px 2px rgba(79, 174, 84, 0.19);
  border-radius: 0.4rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #fff;
}
.btngroup {
  display: flex;
  justify-content: space-around;
  margin-top: 1.6rem;
}
</style>
